import {
    APP_I18N_KEYS
  } from '../../../../features/home/constants/i18n/Appi18nConstants';
  
  export const APP_I18N_EN =  {
    [APP_I18N_KEYS.footer]: "Powered by technologies developed by A*STAR's Institute of High Performance Computing (IHPC)"
  }


// WEBPACK FOOTER //
// ./src/locales/en/features/home/app.i18n.en.js